export const LogoMark = ({ className = "h-8 w-8" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <rect x="0.5" y="0.5" width="63" height="63" rx="16" fill="#2a2c30" stroke="rgb(var(--fg-rgb) / 0.2)" />
    <rect x="19" y="10" width="26" height="44" rx="7" fill="none" stroke="#ECEDEE" strokeWidth="3.5" />
    <path d="M26 23l12 14M38 23L26 37" stroke="#3FD6E6" strokeWidth="4" strokeLinecap="round" />
    <circle cx="32" cy="47" r="2.2" fill="#FF4D80" />
  </svg>
);

export const Logo = () => (
  <span className="flex items-center gap-2.5">
    <LogoMark />
    <span className="font-display text-lg font-semibold tracking-tight sm:text-xl">PhoneSmart<span className="text-[var(--volt)]">X</span></span>
  </span>
);
